export const COOKIES_ACCEPTED_KEY = 'brocoders-cookies-accepted';
